import { AttendanceStatus } from "./attendance-status.enum";
import { Tag } from "./tag";

export interface Attendance {
  id: string;
  companyId?: string;
  status: AttendanceStatus;
  currentContactChannel: ContactChannel;
  contact?: Contact;
  currentAttendant?: Attendant;
  assignedAttendant?: Attendant;
  currentCompany: {
    id: string;
    name: string;
    instagramIntegrity?: boolean;
  };
  stats?: {
    lastContactEventAt: string;
    lastAttendantEventAt: string;
    lastAttendantMessageSentAt?: string;
    waitingForReply: boolean;
    countUnreadMessages: number;
    hasUnreadMessages: boolean;
    freeEntryPoint?: FreeEntryPoint | null;
    freeEntryPointPending?: boolean;
  },
  currentLanguage: string;
  archivedAt?: string;
  lastMessageAt: string;
  isBotStopped: boolean;
  nextContactAttendanceId?: string;
  previousContactAttendanceId?: string;
  tags: Tag[];
  publicId: string;
  metadata?: AttendanceMetadata;
  focusedAttendanceId?: string;
  isContactBlocked?: boolean;
}

export interface FreeEntryPoint {
  active: boolean;
  startedAt: string | null;
  expiresAt: string;
}

export interface AttendanceMetadata {
  bookingReservation?: BookingReservation;
  expediaReservation?: ExpediaReservation;
}

export interface BookingReservation {
  propertyId?: string,
  conversationId?: string,
  conversationType?: string,
  conversationReference?: string
}

export interface ExpediaReservation {
  propertyId?: string,
  conversationId?: string,
  reservationId?: string
}

export enum AttendanceChannel {
  CHAT_WEB = 'chat_web',
  WHATSAPP = 'whatsapp',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  GOOGLE_BUSINESS_MESSAGES = 'google_business_messages',
  EMAIL = 'email',
  PHONE = 'phone',
  BOOKING = 'booking',
  EXPEDIA = 'expedia',
  TIKTOK = 'tiktok',
  TELEGRAM = 'telegram',
}

export interface ContactChannel {
  id: string;
  contactId: string;
  companyId: string;
  channel: AttendanceChannel;
  platform: string;
  companyChannelReferenceId: string;
  contactChannelReferenceId: string;
  channelReferenceId: string;
  isAvailable: boolean;
  isMerged: boolean;
  isBlocked?: boolean;
  lastMessageReceivedAt: string;
  createdAt: string;
  updatedAt: string;
  companyName?: string | null;
}

export interface Contact {
  id: string;
  name?: string;
  email?: string;
  phone: string;
  additionalFields: AdditionalFields;
  mergedContactId?: string;
  hasChannelWhatsApp: boolean;
}

export interface AdditionalFields {
  language: string;
  extra?: string;
}

export interface Attendant {
  id: string;
  name?: string;
  profileImage?: string;
  userReferenceId: string;
  companies?: string[];
}